module.exports = __webpack_public_path__ + "img/no_reviews.e3ebc82b.png";